import { ReactElement } from 'react'

import { BankAccountSource } from '@features/bankAccounts/enums/bankAccountSource'
import { BankAccount } from '@features/bankAccounts/types/bankAccount'
import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { Account } from '@modules-deprecated/app/accounts/types'

import { AccountCard } from '../AccountCard'
import { BankAccountCard } from '../BankAccountCard'
import { OpenBankingAccountCard } from '../OpenBankingAccountCard'

interface AccountCardByTypeProps {
  account: Account
  bankAccountsByAccountId: Map<string, BankAccount>
  openBankingAccountsByAccountId: Map<string | null, OpenBankingAccount>
}

export const AccountCardByType = ({
  account,
  bankAccountsByAccountId,
  openBankingAccountsByAccountId,
}: AccountCardByTypeProps): ReactElement => {
  const bankAccount = bankAccountsByAccountId.get(account.id)
  const openBankingAccount = openBankingAccountsByAccountId.get(account.id)

  if (bankAccount && bankAccount.source === BankAccountSource.SHINE_BANKING) {
    return <BankAccountCard accountNo={account.accountNo} bankAccount={bankAccount} />
  }

  if (openBankingAccount) {
    return (
      <OpenBankingAccountCard
        accountNo={account.accountNo}
        openBankingAccount={openBankingAccount}
        bankAccount={bankAccount}
      />
    )
  }

  return <AccountCard account={account} bankAccount={bankAccount} />
}
